require('./filter-view.component.scss');

class FilterViewController {
  constructor(
    $scope,
    CurrentFilterService,
    CurrentModelService,
    PermissionService,
    RouterService,
    LayoutService,
  ) {
    this.$scope = $scope;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.layout = LayoutService;
  }

  // get isShowStatHeader() {
  //   if (!this.filter) return false;
  //   return this.filter.isChartArea || this.filter.isChart || this.filter.isGraph || this.filter.isTree;
  // }
  //
  // get isReadOnlyStatHeader() {
  //   if (!this.CurrentFilterService || !this.CurrentFilterService.filter) return false;
  //   return this.CurrentFilterService.filter.isDashboard ||
  //     this.CurrentFilterService.filter.isCard;
  // }

  get elementClass() {
    if (!this.router.pdf) return 'maximize';
    else if (!this.CurrentFilterService.filter.isCardOrDashboard) return 'pdf';
    // else if (this.filterView == 'sc-heatmap') return 'pdf-dashboard-200';
    else if (
      this.filterView == 'sc-chart' ||
      this.filterView == 'sc-radar' ||
      this.filterView == 'sc-tree' ||
      this.filterView == 'sc-event-river'
    ) return 'pdf-dashboard-200';
    else return 'pdf-dashboard-100';
  }


  get filterView() {
    if (!this.filter) return '';
    if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled &&
      this.filter.isExplore && this.permission.fact &&
      !this.filter.isViewChat) return 'sc-facts';

    if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled &&
      this.filter.isReport) return 'sc-heatmap';

    if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled &&
      this.filter.isStat) return 'sc-stat-table';

    if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled &&
      this.filter.isSummStat) return 'sc-summ-stat';

    if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled &&
      this.filter.isChart) return 'sc-pie';

    if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled &&
      this.filter.isChartArea) return 'sc-chart';

    if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled &&
      this.filter.isRadar) return 'sc-radar';

    if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled &&
      this.filter.isEventRiver) return 'sc-event-river';

    if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled &&
      this.filter.isTree) return 'sc-tree';

    if (!this.filterData.cancelled && this.filter.isReports &&
      this.filter.isGraph) return 'sc-graph';

    if (!this.filterData.cancelled && this.filter.isReports &&
      !this.filter.isCard) return 'sc-report-frame-view';

    if (!this.filterData.error && !this.filterData.cancelled &&
      this.filter.isViewChat) return 'sc-chat-viewer';

    if (!this.filterData.loading) return 'no-rights';

    return '';
  }

  get isShowFilterStamp() {
    return (this.CurrentFilterService.filter && !this.CurrentFilterService.filter.isCardOrDashboard) &&
      (this.filterView == 'sc-heatmap' ||
        this.filterView == 'sc-pie' ||
        this.filterView == 'sc-chart' ||
        this.filterView == 'sc-event-river' ||
        this.filterView == 'sc-summ-stat' ||
        this.filterView == 'sc-graph' ||
        this.filterView == 'sc-chat-viewer' ||
        this.filterView == 'sc-tree' ||
        this.filterView == 'sc-radar');
  }

  get filter() {
    // return this.router.isFilterEditModal ? this.filterData.filter : this.router.CurrentFilterService.filter;
    return this.filterData ? this.filterData.filter : null;
  }

  get isShowHead() {
    return !this.router.CurrentFilterService.filter;
    // && !this.CurrentFilterService.filter.isDashboard &&
    // !this.CurrentFilterService.filter.isCard;
  }

  get filterBar() {
    return this.CurrentFilterService.filterBar;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get stat() {
    return this.filterData.filterData;
  }

  get activity() {
    return this.filterData.filterData;
  }

  get card() {
    return this.filterData.filterData;
  }

  showMenu() {
    return this.CurrentFilterService.panel !== 'catalog' && !this.layout.hideMenu;
  }

  get repIdSuffix() {
    return this.router.isFilterEditModal ? '-edit' : '';
  }
}

export const FilterViewComponent = {
  template: require('./filter-view.component.html'),
  bindings: {
    filterData: '<',
    maximizeFrame: '<',
    showFactsInfo: '<',
    loadMore: '<',
    clickToUse: '<?',
  },
  controller: FilterViewController,
};



// WEBPACK FOOTER //
// ./src/view/filter-view.component.js